// extracted by mini-css-extract-plugin
export var content = "content-module--content--cee89";